(() => {
  if (customElements.get('pdp-collection-slider')) return;

  class PdpCollectionSlider extends HTMLElement {
    constructor() {
      super();
      this.onCartAdd = this.onCartAdd.bind(this);
      this.onCartChange = this.onCartChange.bind(this);
    }

    connectedCallback() {
      this.filterByCart();
      window.addEventListener('cart:add', this.onCartAdd);
      window.addEventListener('cart:change', this.onCartChange);
    }

    disconnectedCallback() {
      window.removeEventListener('cart:add', this.onCartAdd);
      window.removeEventListener('cart:change', this.onCartChange);
    }

    onCartAdd() {
      this.filterByCart();
    }

    onCartChange() {
      this.filterByCart();
    }

    filterByCart() {
      fetch(`${window.Shopify.routes.root}cart.js`)
        .then((r) => r.json())
        .then((cart) => {
          const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));

          this.querySelectorAll('[data-product-id]').forEach((slide) => {
            slide.hidden = cartProductIds.has(slide.dataset.productId);
          });

          const slider = this.querySelector('[data-slider]');
          if (slider) slider.dispatchEvent(new Event('scroll'));
        })
        .catch(() => {});
    }
  }

  customElements.define('pdp-collection-slider', PdpCollectionSlider);
})();